const { origin } = window.location;
import { localStorageGetItem } from '@/utils/utils';

let url_env = '';
let socket_url = '';
let url_env_bot = '';
let url_env_bot_front = '';
let url_env_self = '';
let RASA_URL = '';
let DATABOT_TEMPLATES = '';
let url_massive_tags = '';
let payment = '';
let jobs = '';
let URL_MICRO_CONVERSATIONS = '';
let conversations = '';
let url_automations = '';
let integrations = '';
let url_metrics = '';
let url_redis = '';

const emails = [
  'nicolas@databot.cl',
  'victor@las@ddatabot.cl',
  'camila@databot.cl',
  'matias@databot.cl',
  'fabian@databot.cl',
  'luis@databot.cl',
  'gabriela@databot.cl',
  'francisco.arancibia@unitedrentacar.cl',
  'mileydis.delacruz@clicar.cl',
  'andres.c@unitedrentacar.cl',
  'chris188p@gmail.com',
  'arodriguez@salfa.cl',
  'douglas@supletech.cl',
  'marcela.aguirre@chileanrentacar.cl',
  'maria.velazquez@chileanrentacar.cl',
  'raraya@mininuts.cl',
  'pedro@mininuts.cl',
  'taller@mininuts.cl',
  'digital@ryk.cl',
  'edwin.armijo@firmaschile.cl',
  'carla.peralta@chileanrentacar.cl',
  'databot_paola@cardinale.zendesk.com',
  'ventasonline@donacarne.cl',
  'ventasonline@darsa.cl',
  'whitney.lara@unitedrentacar.cl',
  'jorgebruno@josimar.com.ar',
  'alejandro.cortes@yumbolon.com',
  'mariab@imahe.cl',
  'callcenter2@sack.cl',
  'marcela.aguirre@chileanrentacar.cl',
  'rosita@ferreteriasweitzler.cl',
  'claudio.lemus@unitedrentacar.cl',
  'nicolas.weitzler@weitzler.cl',
  'francisco.arancibia@unitedrentacar.cl',
];

const databotEmails = [
  'sergio@databot.cl',
  'nicolas@databot.cl',
  'victor@las@ddatabot.cl',
  'camila@databot.cl',
  'matias@databot.cl',
  'fabian@databot.cl',
  'luis@databot.cl',
  'gabriela@databot.cl',
];

const medsEmails = [
  'alejandra.perez@meds.cl',
  'jose.martinez@meds.cl',
  'damian.gonzalez@meds.cl',
  'margarita.arredondo@meds.cl',
  'hector.jara@meds.cl',
  'ignacia.sepulveda@meds.cl',
  'jannett.gonzalez@meds.cl',
  'maria.jerez@meds.cl',
  'isabel.escobar@meds.cl',
  'lucas.alvarado@meds.cl',
  'alexis.pizarro@meds.cl',
  'pablo.herrera@prisa.cl',
  'keyla.rodriguez@prisa.cl',
  'ruth.rodriguez@prisa.cl',
  'carmin.pena@prisa.cl',
  'valeska.urra@prisa.cl',
  'servicioalcliente@prisa.cl',
];

const otrosEmails = [
  'sergio@databot.cl',
  'cherbekian@sb.cl',
  'calamos@sb.cl',
  'kbaeza@sb.cl',
  'rsandovalr@sb.cl',
  'liliana.montezuma@apexamerica.com',
  'melissa.arcis@apexamerica.com',
  'caravenaf@sb.cl',
  'matias@databot.cl',
  'graciela.pina@apexamerica.com',
  'dhidalgo@sb.cl',
  'dbustamante@sb.cl',
  'irina.zambrano@apexamerica.com',
  'susan.fuentes@apexamerica.com',
  'sergio@databot.cl',
  'franco.calderon@apexamerica.com',
  'juan.quezada@apexamerica.com',
  'rosa.cachana@apexamerica.com',
  'nicolas@databot.cl',
  'sbascunan@sb.cl',
  'camila@databot.cl',
  'matias@databot.cl',
  'mpereyra@oxford.cl',
  'sgonzalez@oxford.cl',
  'contactoweb@tiendaoxford.zendesk.com',
  'ydiaz@oxford.cl',
  'onboarding@databot.cl',
  'acalas@oxford.cl'
];

if (origin == 'https://dashboard-front-qa.herokuapp.com') {
  url_env = 'https://qapi.databot.cl';
  // url_env = "https://databot-dashboard-api-qa.herokuapp.com";
  url_env_bot = 'https://chatbot-front-qa.herokuapp.com';
  socket_url = 'https://chatbot-front-qa.herokuapp.com';
  url_env_bot_front = 'http://bot-front-qa.s3-website-us-east-1.amazonaws.com';
  url_env_self = 'https://dashboard-front-qa.herokuapp.com';
  RASA_URL = 'https://rasaia2.databot.cl';
  DATABOT_TEMPLATES = 'https://chatbot-templates-1006876157299.us-east1.run.app';
  url_massive_tags = '';
  payment = 'http://localhost:3100';
  url_automations = 'https://databot-automatizaciones.rj.r.appspot.com';
  URL_MICRO_CONVERSATIONS = 'https://conversations-api-test.databot.cl';
  conversations = 'https://conversations-api-test.databot.cl';
  url_metrics = 'https://metrics-test.databot.cl';
  // jobs = 'https://sidekiqserver.databot.cl';
  integrations = 'https://integrations-app-prod.niceglacier-347ce6fc.southcentralus.azurecontainerapps.io';
  url_redis = 'https://redis-manager-442419.rj.r.appspot.com';
} else if (process.env.NODE_ENV === 'development') {
  url_env = 'http://localhost:3000';
  socket_url = 'http://localhost:5000';
  url_env_bot = 'http://localhost:5000';
  url_env_bot_front = 'http://localhost:8000';
  url_env_self = 'https://ia.databot.cl';
  // RASA_URL = 'http://localhost:9090'; // prod to test new register
  // DATABOT_TEMPLATES = 'http://localhost:3010'; // prod to test new register
  RASA_URL = 'https://rasaia2.databot.cl';
  DATABOT_TEMPLATES = 'https://chatbot-templates-1006876157299.us-east1.run.app';
  url_massive_tags = 'http://localhost:3200';
  payment = 'http://localhost:3100';
  URL_MICRO_CONVERSATIONS = 'http://localhost:3001';
  jobs = 'http://localhost:3000';
  url_automations = 'http://localhost:5500';
  conversations = 'http://localhost:3001';
  integrations = 'http://localhost:3200';
  url_metrics = 'http://localhost:3400';
  url_redis = 'http://localhost:3500';
} else {
  url_env = 'https://api.databot.cl';
  socket_url = 'https://databot-chatbot-backend.herokuapp.com';
  url_env_bot = 'https://databot-chatbot-backend.herokuapp.com';
  url_env_bot_front = 'https://databot-api.herokuapp.com';
  url_env_self = 'https://ia.databot.cl';
  RASA_URL = 'https://rasaia2.databot.cl';
  DATABOT_TEMPLATES = 'https://chatbot-templates-1006876157299.us-east1.run.app';
  url_massive_tags = 'https://api-wsp.databot.cl';
  payment = 'http://localhost:3100';
  jobs = 'https://api.databot.cl';
  url_automations = 'https://databot-automatizaciones.rj.r.appspot.com';
  URL_MICRO_CONVERSATIONS = 'https://conversations.databot.cl';
  conversations = 'https://conversations.databot.cl';
  integrations = 'https://integrations-app-prod.niceglacier-347ce6fc.southcentralus.azurecontainerapps.io';
  url_metrics = 'https://metrics-test.databot.cl';
  url_redis = 'https://redis-manager-442419.rj.r.appspot.com';

  if (medsEmails.includes(localStorageGetItem('uid'))) {
    URL_MICRO_CONVERSATIONS = 'https://conv-rep.databot.cl';
    conversations = 'https://conv-rep.databot.cl';
  } else if (otrosEmails.includes(localStorageGetItem('uid'))) {
    URL_MICRO_CONVERSATIONS = 'https://conv-rep2.databot.cl';
    conversations = 'https://conv-rep2.databot.cl';
  } else {
    URL_MICRO_CONVERSATIONS = 'https://conversations.databot.cl';
    conversations = 'https://conversations.databot.cl';
  }

  // URL_MICRO_CONVERSATIONS = medsEmails.includes(localStorageGetItem('uid'))
  //   ? 'https://conv-rep.databot.cl'
  //   : 'https://conversations.databot.cl';

  // conversations = medsEmails.includes(localStorageGetItem('uid'))
  //   ? 'https://conv-rep.databot.cl'
  //   : 'https://conversations.databot.cl';

  // URL_MICRO_CONVERSATIONS = otrosEmails.includes(localStorageGetItem('uid'))
  //   ? 'https://conv-rep2.databot.cl'
  //   : 'https://conversations.databot.cl';

  // conversations = otrosEmails.includes(localStorageGetItem('uid'))
  //   ? 'https://conv-rep2.databot.cl'
  //   : 'https://conversations.databot.cl';
}

RASA_URL = 'https://rasaia2.databot.cl';
// url_automations = 'https://databot-automatizaciones.rj.r.appspot.com';

// url_env = 'https://api.databot.cl'
// socket_url = 'https://databot-chatbot-backend.herokuapp.com';
// url_env_bot = 'https://databot-chatbot-backend.herokuapp.com';
// url_env_bot_front = 'https://databot-api.herokuapp.com';
// url_env_self = 'https://ia.databot.cl';
// RASA_URL = 'https://rasaia2.databot.cl';
// DATABOT_TEMPLATES = 'https://chatbot-templates-1006876157299.us-east1.run.app';
// url_massive_tags = 'https://api-wsp.databot.cl';
// payment = 'http://localhost:3100';
// jobs = 'https://api.databot.cl';
// url_automations = 'https://databot-automatizaciones.rj.r.appspot.com';
// URL_MICRO_CONVERSATIONS = 'https://conversations.databot.cl';
// conversations = 'https://conversations.databot.cl';
// integrations =
//   'https://integrations-app-prod.niceglacier-347ce6fc.southcentralus.azurecontainerapps.io';
// // url_metrics = 'https://metrics.databot.cl';
// url_metrics = 'https://metrics-test.databot.cl';
// url_redis = 'https://redis-manager-442419.rj.r.appspot.com';

// url_env = 'https://fenix.databot.cl';
// url_metrics = 'https://metrics-test.databot.cl';

export default {
  url_env,
  socket_url,
  url_env_bot,
  url_env_self,
  RASA_URL,
  url_env_bot_front,
  DATABOT_TEMPLATES,
  url_massive_tags,
  payment,
  jobs,
  URL_MICRO_CONVERSATIONS,
  conversations,
  url_automations,
  integrations,
  url_metrics,
  url_redis
};
